import { render } from 'rax'; // import hydrate from 'rax-hydrate';
// import { FPModuleWarp, FPEvent } from '../models';

import * as driverDom from 'driver-dom';
const COMPONENT_CACHE_MAP = {};
export type ComponentRenderParameter = {
  moduleWarp: FPModuleWarp;
  fpPageEvents: FPEvent[];
  containerElement: Element;
};
/**
 * 注册组件
 * @param {string} name - 组件名称
 * @param {FPComponent} c - 组件实现类
 */

export function registerComponent(name: string, c: any) {
  COMPONENT_CACHE_MAP[name] = c;
}
/**
 * 获取已注册的组件
 *
 * @export
 * @param {string} name
 * @returns {FPComponent}
 */

export async function getComponent(props: {
  name: string; // 组件名称

  moduleWarp?: any; //  模块其它信息

}) {
  const {
    name,
    moduleWarp
  } = props;
  let moduleName = name;

  if (moduleName && COMPONENT_CACHE_MAP[moduleName]) {
    return COMPONENT_CACHE_MAP[moduleName];
  } else {}
}
/**
 * Rax Render 方法包装
 *
 * @export
 * @param {JSX.Element} element
 * @param {Element} containerElement
 */

export function renderComponent(element: any, containerElement: HTMLElement) {
  render(element, containerElement, {
    driver: driverDom
  }); // hydrate(element,containerElement);
}